export default __webpack_public_path__ + "static/logo-f081140299fc03f5fb86b3b47850b5b3.jpg";